import * as React from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createDrawerNavigator } from '@react-navigation/drawer';
import { Provider as PaperProvider } from 'react-native-paper';
import { Provider as ReduxProvider } from 'react-redux';
import Amplify, { Auth } from 'aws-amplify';
import AppLoading from 'expo-app-loading';
import * as Font from 'expo-font';

import CustomDrawerContent from './src/components/CustomDrawerContent';
import Home from './src/screens/Home';
import Workout from './src/screens/Workout';
import WorkoutComplete from './src/screens/WorkoutComplete';
import Workouts from './src/screens/Workouts';
import Exercises from './src/screens/Exercises';
import VideoPlayer from './src/screens/VideoPlayer';
import Login from './src/screens/Login';
import Register from './src/screens/Register';
import Profile from './src/screens/Profile';
import configureStore from './src/store/store';
import awsConfig from './src/config/aws';

const robotoRegular = require('./src/assets/fonts/roboto-regular.ttf');
const roboto700 = require('./src/assets/fonts/roboto-700.ttf');

const Drawer = createDrawerNavigator();
let store;

Amplify.configure({
  Auth: {
    mandatorySignIn: false,
    region: awsConfig.region,
    userPoolId: awsConfig.userPoolId,
    userPoolWebClientId: awsConfig.userPoolWebClientId,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
    identityPoolId: awsConfig.identityPoolId,
  },
  Storage: {
    bucket: awsConfig.bucket,
    region: awsConfig.region,
  },
});

async function loadResourcesAsync() {
  try {
    const user = await Auth.currentAuthenticatedUser({});
    store = configureStore({ user });
  } catch (err) {
    // user not logged in
    store = configureStore();
  }

  await Promise.all([
    Font.loadAsync({
      'roboto-regular': robotoRegular,
      'roboto-700': roboto700,
    }),
  ]);
}

function handleLoadingError(error) {
  console.warn(error);
}

function handleFinishLoading(setLoadingComplete) {
  setLoadingComplete(true);
}

function App() {
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);
  if (!isLoadingComplete) {
    return (
      <AppLoading
        startAsync={loadResourcesAsync}
        onError={handleLoadingError}
        onFinish={() => handleFinishLoading(setLoadingComplete)}
      />
    );
  }

  return (
    <ReduxProvider store={store}>
      <PaperProvider>
        <NavigationContainer>
          <Drawer.Navigator
            // eslint-disable-next-line react/jsx-props-no-spreading
            drawerContent={(props) => <CustomDrawerContent {...props} />}
            edgeWidth={0}
          >
            <Drawer.Screen
              name="Home"
              component={Home}
            />
            <Drawer.Screen
              name="Workout"
              component={Workout}
            />
            <Drawer.Screen
              name="Exercises"
              component={Exercises}
            />
            <Drawer.Screen
              name="Workouts"
              component={Workouts}
            />
            <Drawer.Screen
              name="WorkoutComplete"
              component={WorkoutComplete}
            />
            <Drawer.Screen
              name="VideoPlayer"
              component={VideoPlayer}
            />
            <Drawer.Screen
              name="Login"
              component={Login}
            />
            <Drawer.Screen
              name="Register"
              component={Register}
            />
            <Drawer.Screen
              name="Profile"
              component={Profile}
            />
          </Drawer.Navigator>
        </NavigationContainer>
      </PaperProvider>
    </ReduxProvider>
  );
}

export default App;
